import React from "react";
import 'styles/common.scss';
import '@bellsoft-ui-react/core/dist/cjs/index.css';
import '@bellsoft-ui-react/core/dist/esm/index.css';
import '@bellsoft-ui-react/navigation/dist/esm/index.css';
import '@bellsoft-ui-react/modals/dist/esm/index.css';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import "src/styles/simplebars.css";
import {generateCopyButtons} from "./gatsby-browser-modules/codeCopy";
import {generateSimplebars} from "./gatsby-browser-modules/scrollbars";
import {reportRouteChange} from "./gatsby-browser-modules/gaEnhancements";
import {
    ContainerSecurityModalMethod,
    jrushModal,
    SpringSecurityModalMethod,
    WebinarSpringModalMethod,
    wrongDomainModalMethod
} from "./src/util/modals/modalTemplates";
import {appendLeadInfoScript} from "./src/util/ga/gaHelpers";

const initDocSearch = () => {
    if (window && document) {
        try {
            const docSearchStub = document.getElementById("docsearch-stub-btn")
            if (docSearchStub) {
                docSearchStub.style.display = "none"
            }
        } catch (e) {
        }
        if (!(document.getElementById("docsearch")?.innerHTML)) {
            try {
                const {docsearch} = window.__docsearch_meilisearch__;
                docsearch({
                    container: "#docsearch",
                    host: process.env.GATSBY_MEILISEARCH_HOST,
                    apiKey: process.env.GATSBY_MEILISEARCH_PUBLIC_TOKEN,
                    indexUid: "globalsearch",
                });
            } catch (e) {
            }
        }
    }
}

export const onInitialClientRender = () => {
    console.log("ReactDOM.render has executed");

    if (window && document) {

        const script = document.createElement("script")
        script.setAttribute("src", "/assets/js/bootstrap.bundle.min.js");
        script.type = "text/javascript";

        script.onload = function() {
            if (!window["bsClickedModals"]) {
                window["bsClickedModals"] = new Set()
            }

            for (const clickedModal of window["bsClickedModals"]) {
                try {
                    const myModalEl = document.querySelector(clickedModal)
                    window["bsClickedModals"].delete(clickedModal);
                    const modal = window.bootstrap.Modal.getOrCreateInstance(myModalEl)
                    modal.show()
                } catch (e) {

                }
            }
        };

        document.head.appendChild(script)
    }
}

export const onRouteUpdate = ({location, prevLocation}) => {
    initDocSearch();
    appendLeadInfoScript();
    generateCopyButtons(location);
    generateSimplebars();
    reportRouteChange({location, prevLocation});

    if (!location.hash) {
        window.scrollTo({ top: 0 });
    }
    document.documentElement.style.scrollBehavior = "";

    jrushModal();

    // WebinarSpringModalMethod();

    if (!location.pathname?.startsWith('/state-of-container-security-2025')) {
        // ContainerSecurityModalMethod();
    }

    if (!location.pathname?.startsWith('/spring-container-security-2026')) {
        // SpringSecurityModalMethod();
    }
    

    if (!location.pathname?.startsWith("/kubecon") && !location.pathname?.startsWith("/bellsoft-hardened-images/vulnerability-comparisons")) {

        if (["/blog/migration-from-java-8-to-java-17/",
            "/blog/migration-from-java-11-to-java-17/",
            "/blog/bellsoft-brings-the-performance-of-jvm-17-to-jdk-11-with-liberica-jdk-performance-edition/",
            "/blog/bellsoft-released-liberica-jdk-performance-edition-with-jvm-21/",
            "/blog/java-performance-testing-best-practices-tools/",
            "/blog/how-to-increase-the-performance-of-java-applications/",
            "/announcements/2022/06/28/hotspot-vs-openj9-performance-comparison/"
        ].includes(location.pathname)) {
            // jrushUpdateModalMethodForBlog();
        }
    }
    wrongDomainModalMethod();


    if (window && document && prevLocation) {
        if (!window["bsClickedModals"]) {
            window["bsClickedModals"] = new Set()
        }

        window["bsClickedModals"].clear()
    }

    const pathname = location.pathname

    const hreflangs = ["en-US", "en", "x-default"]

    hreflangs.forEach((hrefLang) => {
        let el = document.querySelector(`link[hreflang="${hrefLang}"]`)
        if (!el) {
            el = document.createElement("link")
            el.setAttribute("rel", "alternate")
            el.setAttribute("hreflang", hrefLang)
            document.head.appendChild(el)
        }
        el.setAttribute("href", `${process.env.GATSBY_BELLSW_BASE}${pathname}`)
    })
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  const isNewPage = prevLocation && location.pathname !== prevLocation.pathname;

  if (isNewPage && !location.hash) {
    document.documentElement.style.scrollBehavior = "auto";
  }
};